import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var dropdownItemDangerousVariants = createRuntimeFn({defaultClassName:'fx_c76f37be_mlx0e80',variantClassNames:{danger:{true:'fx_c76f37be_mlx0e81',false:'fx_c76f37be_mlx0e82'}},defaultVariants:{danger:false},compoundVariants:[]});

export { dropdownItemDangerousVariants };
//# sourceMappingURL=item.vanilla.mjs.map
